const Url = {
    getExternalLinkTarget: (d) => d.externalLinkType == 1 ? '_self' : '_blank',
    getHomeLink: function (baseUrl, sub, layout, dataSub, isBuilder) {
        return Url.getLink(baseUrl, '/', { sub, dataSub, layout }, isBuilder);
    },
    getLink: function (baseUrl, path, queryParams, isBuilder) {
        if (isBuilder || path == undefined) {
            return '#';
        }
        let url = `${baseUrl}/`;
        if (path != '/') {
            url += path;
        }
        const query = [];
        if (queryParams) {
            for (let key in queryParams) {
                if (!queryParams[key]) {
                    continue;
                }
                query.push(`${key}=${queryParams[key]}`);
            }
        }
        if (query.length > 0) {
            url += `?${query.join('&')}`;
        }
        return url;
    }
}

export default Url;